import React from "react";
import { Button } from "./ui/button";
import { ArrowRight, CheckCircle } from "lucide-react";
import { mockData } from "../mock";

const Hero = () => {
  const { hero } = mockData;

  return (
    <section
      id="inicio"
      className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden"
    >
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-purple-50 via-blue-50 to-cyan-50 -z-10" />

      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-purple-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob" />
      <div className="absolute top-40 right-10 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000" />
      <div className="absolute bottom-20 left-1/2 w-72 h-72 bg-cyan-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-4000" />

      <div className="container mx-auto max-w-7xl relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Content */}
          <div className="space-y-8">
            <div className="inline-flex items-center space-x-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full shadow-sm border border-purple-100">
              <CheckCircle className="w-5 h-5 text-purple-600" />
              <span className="text-sm font-medium text-gray-700">
                Mais de 30 anos de experiência
              </span>
            </div>

            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-gray-900 leading-tight">
              {hero.title}
            </h1>

            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-700">
              {hero.subtitle}
            </h2>

            <p className="text-lg text-gray-600 leading-relaxed max-w-xl">
              {hero.description}
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button
                size="lg"
                onClick={() =>
                  document
                    .getElementById("planos")
                    ?.scrollIntoView({ behavior: "smooth" })
                }
                className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white text-lg px-8 py-6 shadow-lg hover:shadow-xl transition-all duration-300 group"
              >
                {hero.ctas[0].text}
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>

              <Button
                size="lg"
                variant="outline"
                onClick={() => window.open(hero.ctas[1].link, "_blank")}
                className="text-lg px-8 py-6 border-2 border-purple-600 text-purple-600 hover:bg-purple-50 transition-all duration-300"
              >
                {hero.ctas[1].text}
              </Button>

              <Button
                size="lg"
                variant="ghost"
                onClick={() =>
                  document
                    .getElementById("contato")
                    ?.scrollIntoView({ behavior: "smooth" })
                }
                className="text-lg px-8 py-6 text-gray-700 hover:text-purple-600 hover:bg-purple-50 transition-all duration-300"
              >
                {hero.ctas[2].text}
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="flex flex-wrap items-center gap-6 pt-8 border-t border-gray-200">
              <div className="flex items-center space-x-2">
                <CheckCircle className="w-5 h-5 text-green-600" />
                <span className="text-sm text-gray-600">
                  Sem cartão de crédito
                </span>
              </div>
              <div className="flex items-center space-x-2">
                <CheckCircle className="w-5 h-5 text-green-600" />
                <span className="text-sm text-gray-600">
                  Suporte especializado
                </span>
              </div>
              <div className="flex items-center space-x-2">
                <CheckCircle className="w-5 h-5 text-green-600" />
                <span className="text-sm text-gray-600">
                  Pronto para Reforma Tributária
                </span>
              </div>
            </div>
          </div>

          {/* Right Column - Visual - Mobile Mockup */}
          <div className="relative hidden lg:flex justify-center items-center">
            <div className="relative">
              {/* Phone Frame */}
              <div className="relative w-[280px] h-[560px] bg-gray-900 rounded-[40px] shadow-2xl p-3 border-8 border-gray-800">

                {/* Screen Content */}
                <div className="relative w-full h-full bg-white rounded-[16px] overflow-hidden">
                  <img
                    src="img/dashboard_mobile.png"
                    alt="EEDOC Dashboard Mobile"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              {/* Floating badges around phone */}
              <div className="absolute -top-4 -right-4 bg-white px-4 py-3 rounded-xl shadow-lg border border-gray-200 animate-bounce z-20">
                <p className="text-xs text-gray-500">Documentos Emitidos</p>
                <p className="text-2xl font-bold text-purple-600">5.000+</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Custom animations */}
      <style jsx>{`
        @keyframes blob {
          0%,
          100% {
            transform: translate(0px, 0px) scale(1);
          }
          33% {
            transform: translate(30px, -50px) scale(1.1);
          }
          66% {
            transform: translate(-20px, 20px) scale(0.9);
          }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
      `}</style>
    </section>
  );
};

export default Hero;
